class ReportApiService {

  report = (body: any) => {
    return fetch('https://report-collector.fostcraft.com/telegram', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    });
  }

}

export const reportApiService = new ReportApiService();